import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "study-prove-wrapper" }
const _hoisted_2 = { class: "prove-container-card" }
const _hoisted_3 = { class: "tab-pane-content" }
const _hoisted_4 = { class: "certificate-layout" }
const _hoisted_5 = { class: "certificate-stage" }
const _hoisted_6 = { class: "cert-frame-wrapper" }
const _hoisted_7 = { class: "cert-error-slot" }
const _hoisted_8 = {
  key: 0,
  class: "cert-watermark-overlay"
}
const _hoisted_9 = { class: "certificate-controls" }
const _hoisted_10 = { class: "action-card" }
const _hoisted_11 = { class: "upload-btn-row" }
const _hoisted_12 = { class: "upload-note" }
const _hoisted_13 = { class: "tab-pane-content feedback-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PictureFilled = _resolveComponent("PictureFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_feedback = _resolveComponent("feedback")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
        class: "modern-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "研学 / 游学证明证书",
            name: "first"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "prove-header-bar" }, [
                  _createElementVNode("div", { class: "header-left" }, [
                    _createElementVNode("span", { class: "indicator-bar" }),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", { class: "header-title" }, "研学结业证书底图配置"),
                      _createElementVNode("p", { class: "header-desc" }, " 通关后玩家可领取的数字荣誉证书底图，支持 App 端实时压印姓名与通关日期 ")
                    ])
                  ]),
                  _createElementVNode("div", { class: "header-right" }, [
                    _createElementVNode("span", { class: "ratio-badge" }, "推荐比例 9:16 或 A4竖版 (≤5MB)")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_image, {
                        src: _ctx.baseImage || _ctx.defaultProveImg,
                        fit: "cover",
                        class: "cert-image",
                        "preview-src-list": [_ctx.baseImage || _ctx.defaultProveImg],
                        "preview-teleported": ""
                      }, {
                        error: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_PictureFilled)
                              ]),
                              _: 1
                            }),
                            _cache[1] || (_cache[1] = _createElementVNode("span", null, "暂无证书底图", -1))
                          ])
                        ]),
                        _: 1
                      }, 8, ["src", "preview-src-list"]),
                      (!_ctx.baseImage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("span", { class: "watermark-tag" }, "官方示例模板", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "cert-click-tip" }, "点击证书图可全屏高清放大预览", -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "specs-card" }, [
                      _createElementVNode("h4", { class: "specs-title" }, "证书图样设计建议"),
                      _createElementVNode("ul", { class: "specs-list" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "推荐尺寸："),
                          _createTextVNode(" 1080 × 1920 px (竖版)，确保移动端全屏清晰度。 ")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "留白预留："),
                          _createTextVNode(" 画面正中或靠下方请留出充足空白，供系统自动填入玩家昵称、总得分与游玩日期。 ")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "格式要求："),
                          _createTextVNode(" 支持 JPG / PNG / WEBP，体积不超过 5MB。 ")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_upload, {
                          ref: "uploadRef",
                          class: "single-uploader",
                          action: _ctx.UpdateApi,
                          "show-file-list": false,
                          "before-upload": _ctx.beforeUpload,
                          "on-success": _ctx.onSuccess,
                          "on-error": _ctx.onError
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "large",
                              class: "primary-upload-btn",
                              loading: _ctx.isUploading
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Upload)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.baseImage ? "更换证书底图" : "上传专属证书"), 1)
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }, 8, ["action", "before-upload", "on-success", "on-error"]),
                        (_ctx.baseImage && _ctx.baseImage !== _ctx.defaultProveImg)
                          ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                              key: 0,
                              title: "确认彻底移除该专属证书底图并恢复默认吗？",
                              "confirm-button-text": "确认移除",
                              "cancel-button-text": "取消",
                              "confirm-button-type": "danger",
                              onConfirm: _ctx.handleRemoveImage
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "danger",
                                  plain: "",
                                  size: "large",
                                  class: "remove-btn",
                                  loading: _ctx.isDeleting
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Delete)
                                      ]),
                                      _: 1
                                    }),
                                    _cache[4] || (_cache[4] = _createTextVNode(" 重置为默认模板 ", -1))
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]),
                              _: 1
                            }, 8, ["onConfirm"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_12, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_InfoFilled)
                          ]),
                          _: 1
                        }),
                        _cache[5] || (_cache[5] = _createTextVNode(" 上传新证书后系统将自动保存并覆盖原有模板 ", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "研学调查问卷与反馈",
            name: "second"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_feedback)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
  ]))
}